module.exports = __webpack_public_path__ + "static/media/springville_PH2_bg.b0cd8030.webp";